const MAX_MESSAGES = 200

export class ClientChat {
  constructor(world) {
    this.world = world
    this.messages = []
  }

  init(messages) {
    this.messages = messages ?? []
    this.world.emit('chat', this.messages)
  }

  receive(msg) {
    this.messages.push(msg)
    if (this.messages.length > MAX_MESSAGES) this.messages.shift()
    this.world.emit('chat', this.messages)
  }

  send(text) {
    if (!text || typeof text !== 'string') return
    text = text.trim()
    if (!text) return
    this.world.send({ type: 'chat', text })
  }
}
